// export type Props = {
//   value: string
//   valueLength: number
//   autoFocus?: boolean
//   onChange: (value: string) => void
// }

// export default function OtpInput(props: any) {
//   return (
//     <div className='otp-group'>
//       {[1, 2, 3, 4].map((digit, index) => (
//         <input
//           key={index}
//           type='number'
//           autoComplete='one-time-code'
//           className='otp-input fs-22 fw-600 h-60px w-60px'
//           value={props.value.length ? props.value[index] : ''}
//           style={{border: 'solid 0.5px #e0e0df'}}
//           onChange={(e: any) => {
//             props.onChange(e.target.value, index)
//           }}
//           maxLength={1}
//           autoFocus
//           ref={(el: any) => (props.inputRefs.current[index] = el)}
//           name={index.toString()}
//         />
//       ))}
//     </div>
//   )
// }
export type Props = {
  value: string[] | any
  valueLength: number
  autoFocus?: boolean
  onChange: (value: string, index: number) => void
  inputRefs?: any
}

export default function OtpInput(props: any) {
  const length = props.valueLength || 6
  const values = props.value || []

  const handleChange = (e: any, index: number) => {
    const val = (e.target.value || '').slice(-1)
    props.onChange(val, index)
    if (val) {
      const next = props.inputRefs?.current?.[index + 1]
      if (next) next.focus()
    }
  }

  const handlePaste = (e: any) => {
    e.preventDefault()
    const paste = (e.clipboardData || (e as any).clipboardData)?.getData('text') || ''
    const chars = paste.replace(/\s+/g, '').split('').slice(0, length)
    chars.forEach((ch: string, i: number) => {
      props.onChange(ch, i)
    })
    const focusIndex = Math.min(chars.length, length - 1)
    const focusEl = props.inputRefs?.current?.[focusIndex]
    if (focusEl) focusEl.focus()
  }

  return (
    <div className='otp-group'>
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          type='text'
          inputMode='numeric'
          pattern='\d*'
          autoComplete='one-time-code'
          className='otp-input fs-22 fw-600 h-60px w-60px'
          value={values.length ? values[index] || '' : ''}
          style={{ border: 'solid 0.5px #e0e0df' }}
          onChange={(e: any) => handleChange(e, index)}
          onPaste={handlePaste}
          maxLength={1}
          autoFocus={props.autoFocus && index === 0}
          ref={(el: any) => (props.inputRefs.current[index] = el)}
          name={index.toString()}
        />
      ))}
    </div>
  )
}
